import { he } from "vuetify/lib/locale";

export default {
  direction: "rtl",
  ...he,
  Models: {
    InvoiceDebtRequestModel: {
      title: 'הפקת דו"ח חשבוניות פתוחות ללקוח',
      contentText: 'בקשה להפקת הדו"ח נשלחה בהצלחה למייל:',
    },
    loading: "אנא המתן...",
    MailingModel: {
      title: "הרשמה לדיוור",
      lineOne:
        "אנחנו ב-RGIFT כאן כדי להעניק לך לא רק מוצרים מדהימים, אלא גם מבצעים שווים והטבות בלעדיות! ",
      lineTwo: "כדי להבטיח שתקבל/י את כל העדכונים וההטבות, יש לסמן:",
      lineThree:
        "הסימון מאפשר לנו לשמור אותך מעודכן ולהעניק לך את השירות הטוב ביותר.",
      lineFour: "תודה שבחרת בנו!",
      singedToMailing: "אישור קבלת דיוור",
    },
    LoginModel: {
      registerSide: {
        title: "ברוכים הבאים ל-RGIFT!",
        paragraphOne:
          "כאן תמצאו את כל מה שצריך כדי להפוך כל רגע לחגיגה: מוצרים לעיצוב הבית, ימי הולדת, אירועים מיוחדים ועוד.",
        titleParagraphTwo: "מה תוכלו לעשות באתר?",
        dotOne: "לסייר במגוון רחב של מוצרים מעוצבים ואיכותיים.",
        dotTwo: "להרכיב עגלה מסודרת ונוחה עם כל הפריטים שאתם צריכים.",
        dotThree:
          "לשלוח את העגלה בקלות כהצעת מחיר למשרד שלנו – כך שנציג מטעמנו יחזור אליכם במהירות ויעזור לכם להשלים את ההזמנה.",
        paragraphTwo:
          "לאחר שתתחילו לעבוד איתנו ותהפכו ללקוחות קבועים, תיהנו גם מהטבות מיוחדות וממחירים מותאמים אישית!",
        endParagraph: "צוות RGIFT כאן לשירותכם – קל, נוח ומהנה!",
        registerButton: "הרשמה כלקוח RGIFT",
        loginAsGuest: "המשך כאורח",
        moveLink: "לקוחות קיימים?",
      },
      loginSide: {
        title: "כניסה לפורטל לקוחות RGIFT",
        subTitle: "כניסה ללקוחות קיימים",
        moveLink: "לקוחות חדשים?",
      },
    },
  },
  AccountPage: {
    UserBasicInfo: {
      title: "שלום, ",
    },
    UserInfo: {
      email: "כתובת מייל",
      address: "כתובת למשלוח",
      logoutLink: "יציאה מהחשבון",
    },
    UserAccoutingItem: {
      ofPrice: "מתוך",
      obligo: "ניצול אובליגו",
      balance: "יתרת חובה/זכות",
      payBillBtn: "תשלום יתרת חוב",
    },
    downloadCatalogueBtn: "הורדת כרטסת",
    ordersFilterTab: "הזמנות",
    invoicesFilterTab: "חשבוניות",
    searchOrderPlaceHolder: "חיפוש לפי מס’ הזמנה, הזמנתכם..",
    searchInvoicePlaceHolder: "חיפוש לפי מס' חשבונית...",
  },
  LoginPage: {
    loginFormTitle: "מערכת הזמנות RGIFT",
    userInputPlaceHolder: "מספר פאלפון",
    enterPhoneNumberOrMail: "מספר פלאפון להתחברות",
    enterCode: "הכנס את הקוד שקיבלת לפלאפון/מייל",
    welcome: " ברוכים הבאים לחוויית השירות המהירה והנוחה רק ללקוחות RGIFT.",
    passwordPlaceholder: "סיסמה..",
    missingPhoneOrMail: "יש להזין מספר פלאפון או מייל",
    errorLoginServerSide: "ארעה שגיאה בניסיון ההתחברות",
    emptyOtpInput: "שדה הקוד אינו יכול להיות ריק",
    mandatoryFieldError: "שדה חובה",
    loginButton: "קבל קוד לכניסה",
    eneter: "כניסה",
    forgetPassButton: "שכחת סיסמה?",
  },
  Header: {
    toOrderSite: "הזמנה חדשה",
    personalArea: "אזור אישי",
    login: "התחברות",
  },

  Footer: {
    contactTitle: "לעזרה בכל נושא",
    safetyText: "האתר מאובטח באמצעות SSL",
  },

  ProductWidget: {
    SKU: 'מק"ט',
    name: "שם מוצר",
    description: "תאור",
    partPrice: "מחיר ליחידה",
    partFamily: "מש. מוצר",
    basePrice: "מחיר בסיס",
    discount: "הנחה",
    finalPrice: 'סה"כ מחיר',
    orderNumber: "הזמנה",
    reference: "הזמנתכם",
    quantity: "יחידות",
    sentQuantity: "כמות שנשלחה",
    sumPrice: "סכום",
    approvedStatus: "סטטוס אישור",
    returnReason: "סיבת החזרה",
    approved: "אושר",
    rejected: "לא אושר",
    refundReasonErrorMsg: "חובה לציין את סיבת ההחזרה",
    priceIncludeTax: 'מחיר כולל מע"מ',
  },
  Breadcrumb: {
    home: "ראשי",
    products: "מוצרים",
  },
  Products: {
    clearAll: "נקה הכל",
    overFiftyProducts:
      "יוצגו רק 50 תוצאות ראשונות, ניתן להשתמש במסננים לתוצאות נוספות",
    moreProductsAvailable:
      "ניתן למצוא מוצרים נוספים בעת שימוש בסינונים בראש העמוד.",
    noProductsWereFound: "לא נמצאו מוצרים להצגה",
    productItem: {
      priceLabel: "מחיר ליח'",
      sku: 'מק"ט',
      category: "מש.מוצר",
      description: "תאור",
      addition: "הוספה",
      discount: "הנחה",
      package: "במארז",
      AvailableInStock: "במלאי",
      outOfStock: "אזל המלאי",
      unitOfSale: "יח מכירה",
      width: "רוחב",
      height: "גובה",
      length: "אורך",
      weight: "משקל",
      status: "סטטוס מוצר",
      volume: "נפח",
      moreInfo: "למידע נוסף",
    },
    addToPriceList: {
      title: "בקשת הצעת מחיר עבור",
      message: " הבקשה תשלח למשרד, האם ברצונך להמשיך? ",
      send: "שליחה",
      cancel: "ביטול",
    },
  },
  ProductModal: {
    alreadyInCart: "מוצר זה קיים בעגלה",
    notCustPart: "לידיעתך, מוצר זה אינו קיים בקבוצת המוצרים שלך.",
    orderLine: "שורת הזמנה",
    note: "הערה למוצר",
    save: "הוסף לסל",
    cancel: "ביטול",
    inbox: "האם לארוז?",
    moreDetails: "פרטים נוספים",

    quantity: "כמות גליונות:",
    gilyonLength: "אורך הגליון..",
    gilyonWidth: "רוחב הגליון..",

    galilLength: "אורך הגליל במטרים..",
    galilCutWidth: 'רוחב לחיתוך בס"מ..',
    total: 'סה"כ רוחב מצטבר',
    cm: 'ס"מ',
    validWidths: "רוחבי גלילים אפשריים:",
    numOfCycles: "מס' מחזורים:",
    invalidTotalWidth:
      "סכום רוחבי הפרוסות לא תואם את הרוחבים האפשריים ולכן צפוי פחת של ",
    unbox: "לא ארוז",
    boxed: "ארוז",
    sheets: "גליונות",
    galilee: "גלילים",
    notvalidWidth: 'סה"כ רוחב לא אפשרי - רוחב מקסימלי',
    numberCuts: 'רוחב פרוסה בס"מ',
    numberCycles: "מספר פרוסות",
    phatAlert: "יש לתאם עם התפי",
    duplicateCutsAlert: "לא ניתן לחזור על רוחב פרוסה יותר מפעם אחת",
    inboxAlert: "הכמות הסופית של הגיליונות תאושר על ידי התפי",
    // width
    // rgift
    realatedProducts: "מוצרים קשורים",
  },

  SingelDoc: {
    backButton: "חזרה",
    shipAddress: "כתובת למשלוח",
    contact: "איש קשר",
    status: "סטטוס",
    contactTooltip: "ניתן לשנות איש קשר רק לאחר ביצוע ההזמנה",
    Remarks: "הערה",
    maxLetters: "מקסימום 120 תווים",
  },

  SingleOrder: {
    downloadPdfButtn: "הורדת מסמך הזמנה",
    priceInludeDiscount: "הנחה",
    copyLinesBtn: "העתקת שורות הזמנה",
    NewOrder: "הזמנה חדשה",
    OrderNumber: "הזמנה",
    shippingCode: "קוד משלוח",
    PurchaseOrderNumber: "מס' הזמנתכם",
    contact: "איש קשר",
    status: "סטטוס",
    orderDetails: " פריטים בהזמנה",
    Remarks: "הערות",
    SendOrder: "שליחת הזמנה",
    ProductionDate: "תאריך יצירה",
    orderNumber: "מס' הזמנה",
    sent: "נשלחה",
    Update: "עריכת הזמנה",
    inpPreparation: "בהכנה",
    registered: "נקלטה",
    maxLetters: "מקסימום 120 תווים",
    ordersEmpty: "הזמנתך ריקה.",
    viewDeliveryDoc: "צפייה בתעודה",
    savedBeforeSendOrder: "ההזמנה לא נשמרה לפי השליחה",
    contactTooltip: "ניתן לשנות איש קשר רק לאחר ביצוע ההזמנה",
    orderSummaryTitle: 'סה"כ להזמנה',
    orderCountItems: "יחידות",
    orderPackagesCount: "במארז",
    priceBeforeTax: 'מחיר לפני מע"מ',
    priceIncludeTax: 'מחיר כולל מע"מ',
    tax: 'מע"מ',
    finishEdit: "סיום עריכה",
    cancelEdit: "ביטול עריכה",
    cancelCopy: "ביטול העתקה",
    copyAll: "העתקת כל השורות",
    addMarkedLinesToCart: "הוספת מסומנים לעגלה",
    SendOrderSuccessMassage:
      "ההזמנה תשודר בקרוב למערכת ותבחן על ידי צוות התפי, אישור הזמנה ישלח למייל",
    SendOrderSuccessTitle: "הזמנתך נשלחה בהצלחה",
    SendOrderFailedTitle: "אירעה תקלה בשליחת הזמנה",
    SendOrderFailedMassage: "ההזמנה לא נקלתה אנא נסה שנית עוד כמה דקות",
  },

  finances: {
    table: {
      accounting: {
        invoiceDate: "תאריך חשבונית",
        maturityDate: "תאריך פרעון",
        backlogDays: "ימי פיגור",
        order: "הזמנה",
        yourOrder: "הזמנתכם",
        invoice: "חשבונית",
        typeOfMovement: "סוג תנועה",
        details: "פרטים",
        debit: "חובה",
        sum: "סכום",
        currency: "מטח",
      },
      catalogue: {
        balanceDate: "תאריך מאזן",
        valueDate: "תאריך  ערך",
        referenceTwo: "אסמכתא 2",
        details: "פרטים",
        counterAccountDescription: "תאור חשבון נגדי",
        noJournalMovement: "מס.תנועת היומן",
        typeOfMovement: "סוג תנועה",
        debit: "חובה",
        credit: "זכות",
        cumulativeBalance: "יתרה מצטברת",
        currency: "מטח",
      },
    },
  },

  SingelInvoice: {
    priceInludeDiscount: "הנחה",
    CountItems: "יחידות",
    PackagesCount: "במארז",
    priceBeforeTax: 'מחיר לפני מע"מ',
    priceIncludeTax: 'מחיר כולל מע"מ',
    tax: 'מע"מ',
    downloadPdfButtn: "הורדת עותק חשבונית",
    invoiceNumber: "חשבונית",
    invoiceDetails: "פריטים בחשבונית",
    refundRequest: "יצירת בקשת החזרה",
    summaryTitle: 'סה"כ לחשבונית',
    sendRefundRequest: "שליחת בקשת החזרה",
    cancelRefundRequest: "ביטול בקשת החזרה",
    printCopy: "הפקת עותק חשבונית",
    addQuant: "הוספה להחזרה",
    refundReason: "סיבת החזרה...",
    printModalTitle: "בקשתך נקלטה בהצלחה",
    printModalContent: 'המסמך המבוקש ישלח בדקות הקרובות לדוא"ל',
    printModalCloseBtn: "סגירה",
    cantBeReturned: "החזרת המוצרים כבר אינה אפשרית",
  },

  SingelReturnCustDoc: {
    docnoNumber: "תעודת סחורה מלקוח",
    docnoDetails: "פריטים בתעודה",
  },

  Categories: {
    title: "קטגוריות מוצרים",
    favorites: "מועדפים",
    allProducts: "כל המוצרים",
    myProducts: "המוצרים שלי",
    viewOrder: "צפיה בהזמנה »",
    langFieldName: "familyname",
  },

  BaseSearch: {
    search: "חיפוש",
    placeholder: "חיפוש לפי שם מוצר, מק”ט, תכונה",
  },

  sideBar: {
    OrderToAprove: {
      title: "הזמנות לאישור",
    },
    seeAll: "הצג הכל",
    Invoice: {
      title: "חשבונית",
    },
    returncustdocs: {
      title: "החזרות סחורה",
      showAll: "הצג הכל",
    },
    Order: {
      title: "הזמנה",
    },
    Category: {
      title: "מוצרים",
    },
    orders: {
      title: "ההזמנות שלי",
      orderStatus: "הזמנות",
      showAll: "כל ההזמנות",
    },
    invocies: {
      title: "חשבוניות והחזרות",
      showAll: "הצג הכל",
      titleListOne: "חשבוניות וזיכויים",
      titleListTwo: "בקשות החזרת סחורה",
    },
    finances: {
      title: "כספים",
      showAll: "גיול חובות",
    },
    cart: {
      title: "הזמנה חדשה",
    },
  },
  orders: {
    myOrders: "ההזמנות שלי",
    addressForDelivery: "כתובת למשלוח",
    searchBySKU: "חיפוש לפי מק”ט, מס’ הזמנה",
    sum: "סכום",
    status: "סטטוס",
    productionDate: "תאריך יצירה",
    docNumber: "הזמנה",
    deliveryCertificate: "תעודת משלוח",
    DeliveryCertificatenNotProvided: "תעודת משלוח טרם סופקה",
    dueDate: "תאריך אספקה",
    reference: "הזמנתכם",
  },
  adminPanel: {
    myOrders: "ההזמנות שלי",
    addressForDelivery: "כתובת למשלוח",
    searchBySKU: "חיפוש לפי מק”ט, מס’ הזמנה",
    sum: "סכום",
    status: "סטטוס",
    productionDate: "תאריך יצירה",
    docNumber: "הזמנה",
    deliveryCertificate: "תעודת משלוח",
    DeliveryCertificatenNotProvided: "תעודת משלוח טרם סופקה",
    dueDate: "תאריך אספקה",
    reference: "הזמנתכם",
    action: "פעולות",
    userName: "שם משתשמש",
    customerName: "שם לקוח",
  },
  invocies: {
    searchBySKU: "חיפוש לפי מק”ט, מס’ חשבונית",
    docNumber: "חשבונית",
    productionDate: "תאריך יצירה",
    sum: "סכום",
    status: "סטטוס",
    dueDate: "תאריך פירעון",
  },
  checkOut: {
    nereastDate: "צפי משוער עד כ-%s ימי עסקים",
    titleDelivery: "בחירת מועד משלוח",
    deliveryAddress: "כתובת המשלוח",
    titlePayment: "שיטת תשלום",
    discountLabelCredit: "5% הנחה בתשלום באשראי",
    creditCardMethodText: "תשלום באמצעות כרטיס אשראי",
    back: "חזרה",
    minOrderTitle: "מינימום ההזמנה",
    minOrderText: "שימו לב, מינימום הזמנה",
    remainingAmount: "נותר",
    toOrder: "להזמנה",
    nearestDelivery: "הקרוב ביותר",
    tomorrowDelivery: "מחר",
    laterDelivery: "מועד מאוחר יותר",
    chooseDateText: "בחירת תאריך משוער לקבלת ההזמנה",
    noteTitle: "הערה להזמנה",
    notePlaceholder: "הוסיפו הערות לגבי המשלוח או ההזמנה...",
    obligoPayment: "תשלום מיתרת אובליגו",
    creditBalance: "יתרת זכות",
    shekel: "₪",
    websitePolicyAgree: "הסכמה",
    websitePolicyLink: "למדיניות האתר",
    exceededMaxBalance: "שים לב! הזמנתך חורגת ממכסת האובליגו שמוגדר ללקוח",
    notAllowToPayWithObligo: "הלקוח אינו מורשה לשלם באמצעות אובליגו",
    obligoUsage: "שימוש באובליגו",
    obligoLimit: "מכסת אובליגו",
    cardPayment: "תשלום בכרטיס אשראי",
  },
  returncustdocs: {
    searchBySKU: "חיפוש לפי מק”ט, מס' תעודת סחורה",
    docNumber: "חשבונית",
    productionDate: "תאריך יצירה",
    sum: "סכום",
    status: "סטטוס",
    dueDate: "תאריך פירעון",
    returnDocStatus: "סטטוס החזרה",
    returned: "הוחזר",
    inProcess: "בהמתנה לאישור",
  },
  home: {
    welcome: "ברוכים הבאים לאתר ההזמנות של גוגלי",
    start: "אפשר להתחיל",
    card: {
      subTitle:
        "מבחר מרהיב של מוצרי נוי כמו אגרטלים ועצי פלסטיק מעוצבים, לצד פריטים ייחודיים לימי הולדת ואריזות בסטייל.",
      btn: "הזמנה חדשה",
      viewCataloge: "צפייה בקטלוג",
    },
    about: {
      subTitle:
        "אנו מתמחים בהפיכת כל רגע לחגיגה בלתי נשכחת, עם מבחר עצום של מוצרי נוי, מוצרים לימי הולדת, אריזות, שקיות ועוד. אנו מספקים ללקוחותינו שילוב של איכות, עיצוב, ויחס אישי המותאם לצרכים הייחודיים שלהם.",
      cardOneTitle: "לקוח עסקי ?",
      cardOneContent:
        "אם אתם עסק שמחפש פתרונות מרהיבים ומיוחדים, RGIFT מציעה לכם מבחר עצום של מוצרים ייחודיים, באיכות הגבוהה ביותר ובמגוון רחב של סגנונות ועיצובים. אנו מתחייבים למשלוח מהיר ומדויק וליחס אישי, כדי להבטיח שהמוצרים יגיעו אליכם בדיוק בזמן המתאים ביותר עבורכם.",
      cardTwoTitle: "מארגנים אירוע גדול ?",
      cardTwoContent:
        "מארגנים אירוע גדול? מתכננים חגיגה בלתי נשכחת? אצלנו תמצאו את כל מה שאתם צריכים במקום אחד. מסטייל ייחודי למתנות ועד לפרטים הקטנים שישדרגו כל אירוע – RGIFT כאן כדי לעזור לכם להפוך כל חגיגה לחוויה מרהיבה. אצלנו תוכלו לבצע קניות גדולות בקלות ובנוחות, עם שירות מהיר ואיכותי שיתאים בדיוק לצרכים שלכם.",
    },
    form: {
      title: "למה לקוחות בוחרים ב-RGIFT?",

      subTitle:
        "אנחנו מבינים את החשיבות של שירות מהיר ויעיל עבור העסק שלכם, ולכן אנו מספקים שיטות משלוח מהירות, יחס אישי, ומענה מקצועי לצרכים המיוחדים שלכם. כל זאת כדי להבטיח שאתם מקבלים את המוצרים והשרות הטובים ביותר בזמן הנכון.",
      pointOne: "שירות מהיר ובזמן, המותאם במיוחד לצרכים העסקיים שלך",
      pointTwo: " צוות מומחים שמבין את צרכי העסק שלך ומספק שירות מותאם אישית",
      pointThree: "פתרונות גמישים ואיכותיים לכל עסק, קטן כגדול",
      pointFour: "פתרונות יעילים עבור הזמנות בהיקפים רחבים",
      pointFive: "פתרונות גמישים ואיכותיים לכל עסק, קטן כגדול",
      formTitle: "רוצים להתייעץ איתנו?",
      successed: "הטופס נשלחה בהצלחה!",
      failed: "אופס, משהו השתבש, יש לנסות מאוחר יותר",
      formSubTitle: "יש למלא את כל הפרטים ונציג יחזור אליכם בהקדם",
      name: "שם מלא",
      email: "דואר",
      phone: "פלאפון",
    },
  },
  DownloadAppPage: {
    contentTitle: "יש לנו אפליקצייה!",
    contentSubTitle:
      "כדי שתוכל להינות מאפליקציית Rgift עליך להוריד את אפליקצייה למכשירך",
    installButton: "להתקנת האפליקצייה",
    titleIOSSheet: "משתמש/ת באייפון?",
    titleAndroidSheet: "משתמש/ת באנדרואיד?",
    titleDesktopSheet: "משתמש/ת במחשב?",
    subTitleDesktopSheet: "להתקנת האפליקצייה במחשב יש לעקוב אחר השלבים הבאים",
    subTitleIOSSheet:
      "להתקנת האפליקצייה למשתמשי אייפון יש לעקוב אחר השלבים הבאים",
    subTitleAndroidSheet:
      "להתקנת האפליקצייה למשתמשי אנדרואיד יש לעקוב אחר השלבים הבאים",
    sheetInstructIOSOne: "יש ללחוץ על הסמלון הבא",
    sheetInstructDesktopOne: "יש ללחוץ על הסמלון הבא",
    sheetInstructAndroidOne: "יש ללחוץ על שלוש הנקודות",
    sheetInstructTwo: "בחר/י",
    sheetInstructDesktopTwo: "לחצ/י על כפתור ההתקנה",
    sheetInstructTwoDes: "הוספה למסך הבית",
  },
  QuotationModal: {
    form: {
      title: "שליחת הצעת מחיר",
      name: "שם מלא",
      companyName: "שם חברה",
      email: "דואר אלקטרוני",
      phone: "פלאפון",
      submitButton: "שליחת הצעה",
      cancelButton: "ביטול",
      sentMessage: "נציג יצור איתך קשר בהקדם",
      notes: "הערות",
      notesPlaceholder: "הוסיפו הערות נוספות...",
    },
  },
  orderSuccModal: {
    title: "הזמנך נקלטה בהצלחה",
    orderNumber: "מספר הזמנה",
    alertText:
      'ייתכן שמחלקת תפ"י תבצע התאמות נוספות, נעדכן אותך במידה ויהיה שינוי.',
    watchOrder: "לצפייה בהזמנה",
    processingYourRequest: "מטפלים בפניתך",
    continueOrdering: "המשך להזמין",
  },

  downloadButtonWidget: {
    buttonText: "הורדת קובץ",
  },

  filtersWidget: {
    dateLabel: "מתאריך",
    ordersAndInvoicesDateLabel: "תאריך יצירה",
  },

  CartWidget: {
    title: "עגלת שלך",
    emptyCartTitle: "עגלת הקניות שלך ריקה...",
    cleanCartBtn: "ניקוי הסל",
    startOrderBtn: "התחל להזמין",
    orderSummaryTitle: "לסיכום הזמנה",
  },
  CartSummary: {
    title: "סיכום",
    units: "יחידות",
    packages: "במארז",
    priceBeforeSavings: "מחיר לאחר הנחה",
    totalSavings: "הנחה כללית",
    priceBeforeVAT: 'מחיר לפני מע"מ',
    priceWithDiscount: "מחיר כולל הנחה",
    vat: 'מע"מ',
    totalPayment: 'סה"כ לתשלום',
    finishOrder: "לסיום הזמנה",
    guestFinishOrder: "לשליחת הצעת מחיר",
  },
};
